import React from 'react';

function TrunkIp(props) {
  const { changeValues, tenants, values = {}, canEditName = true } = props;
  /*
    IP:
      {
        "provider": "Embratel",
        "ipSbcTrunk": "172.23.25.100",
        "ipLocal": "200.201.11.12",
        "trunkNumber": "1432230303",
        "codec": "alaw",
        "authUsername": "",
        "password": "",
        "type": "IP"
      }
  */

  return (
    <div>
      <div className="form-row">
        <div className="form-field form-field-small">
          <label className="form-label">Operadora</label>
          <input 
            className="form-input" 
            name="provider" 
            type="text" 
            defaultValue={values.provider || ''} 
            onChange={(e) => changeValues(e.target)} 
            placeholder="Nome"
            disabled={!canEditName}
            title={!canEditName ? 'O nome não pode ser alterado pois o tronco possui configurações de chamadas ativas' : ''}
            style={{ opacity: !canEditName ? 0.6 : 1, cursor: !canEditName ? 'not-allowed' : 'text' }}
          />
          <p name="provider-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
        </div>
        <div className="form-field form-field-small">
          <label className="form-label">Tronco</label>
          <input className="form-input" name="trunkNumber" type="text" defaultValue={values.trunkNumber || ''} onChange={(e) => changeValues(e.target)} placeholder="1431110000" />
          <p name="trunkNumber-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
        </div>
        <div className="form-field form-field-small">
          <label className="form-label">Cliente</label>
          <select className="form-select" name="tenant" value={values.tenant || ''} onChange={(e) => changeValues(e.target)}>
            <option value="">Selecione</option>
            {tenants.map((tenant) => (
              <option key={`${tenant.short_name}`} value={tenant.short_name}>{tenant.name}</option>
            ))}
          </select>
        </div>
        <div className="form-field form-field-small">
          <label className="form-label">Modo</label>
          <select className="form-select" name="mode" value={values.mode || ''} onChange={(e) => changeValues(e.target)}>
            <option value="">Selecione</option>
            <option value="bidirecional">Bidirecional</option>
            <option value="unidirecional">Unidirecional</option>
          </select>
        </div>
      </div>

      <div className="form-row" id="realNumber-field" style={{display: 'none'}}>
        <div className="form-field form-field-large">
          <label className="form-label">Número Real</label>
          <input className="form-input" name="realNumber" type="text" defaultValue={values.realNumber || ''} onChange={(e) => changeValues(e.target)} placeholder="11999887766" />
          <p name="realNumber-invalid-data" className="form-error is-hidden">Campo obrigatório para modo unidirecional!</p>
        </div>
      </div>

      <div className="form-row">
        <div className="form-field form-field-medium">
          <label className="form-label">IP SIP (Operadora)</label>
          <input className="form-input" name="ipSbcTrunk" type="text" defaultValue={values.ipSbcTrunk || ''} onBlur={(e) => changeValues(e.target)} placeholder="1.0.0.1" />
          <p name="ipSbcTrunk-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
        </div>
        <div className="form-field form-field-medium">
          <label className="form-label">IP Local (Central)</label>
          <input className="form-input" name="ipLocal" type="text" defaultValue={values.ipLocal || ''} onBlur={(e) => changeValues(e.target)} placeholder="2.0.0.1" />
          <p name="ipLocal-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
        </div>
        <div className="form-field form-field-medium">
          <div className="codec-group">
            <div className="codec-group-title">Codec</div>
            <div className="codec-options">
              <div className="codec-option">
                <label>G.729</label>
                <input className="codec-checkbox" name="codec" type="checkbox" value="g729" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('g729') : values.codec.toString().includes('g729'))} onChange={(e) => changeValues(e.target)} />
              </div>
              <div className="codec-option">
                <label>ALAW</label>
                <input className="codec-checkbox" name="codec" type="checkbox" value="alaw" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('alaw') : values.codec.toString().includes('alaw'))} onChange={(e) => changeValues(e.target)} />
              </div>
              <div className="codec-option">
                <label>ULAW</label>
                <input className="codec-checkbox" name="codec" type="checkbox" value="ulaw" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('ulaw') : values.codec.toString().includes('ulaw'))} onChange={(e) => changeValues(e.target)} />
              </div>
              <div className="codec-option">
                <label>H.264</label>
                <input className="codec-checkbox" name="codec" type="checkbox" value="h264" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('h264') : values.codec.toString().includes('h264'))} onChange={(e) => changeValues(e.target)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrunkIp;
